<div class="modal-header">
  <h4 class="modal-title">
    Add Date Range Option
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-6">
      <label for="start_date">Start Date</label>
      <app-date-picker [id]="'start_date'"
                       [(content)]="dateRangeOption.start_date"></app-date-picker>
    </div>
    <div class="col-6">
      <label for="end_date">End Date</label>
      <app-date-picker [id]="'end_date'"
                       [(content)]="dateRangeOption.end_date"></app-date-picker>
    </div>
  </div>
  <small class="form-text text-muted">
    Starting on the end date, the membership will no longer be usable for check-in. For example, in order to offer a membership spanning the month of January 2024, the start date would be set to {{ dateStringFromISO8601('2024-01-01') }} and the end date would be set to {{ dateStringFromISO8601('2024-02-01') }}.
  </small>

  <div *ngIf="errorMessage() !== null"
       class="alert alert-danger mt-2 mb-0">
    {{ errorMessage() }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          (click)="handleSubmit()"
          [disabled]="!inputsValid()"
          [class.disabled]="!inputsValid()">
    Submit
  </button>
</div>
